import { LinearGradient } from 'expo-linear-gradient';
import { memo, ReactNode, useMemo } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useTheme } from 'styled-components';

export const LaunchScreenLikePageContainer = memo(
  ({
    transparent,
    children,
    style,
  }: {
    transparent?: boolean;
    children?: ReactNode;
    style?: StyleProp<ViewStyle>;
  }) => {
    const theme = useTheme();
    const bgColor = theme.launchScreen.bgColor;
    const colors = useMemo(
      () => (Array.isArray(bgColor) ? bgColor : [bgColor, bgColor]),
      [bgColor],
    );
    if (transparent) {
      return (
        <View
          css={`
            flex: 1;
          `}
          style={style}
        >
          {children}
        </View>
      );
    }
    return (
      <LinearGradient
        colors={colors}
        start={{ x: 0, y: 0.5 }}
        end={{ x: 1, y: 1 }}
        css={`
          flex: 1;
        `}
      >
        {children}
      </LinearGradient>
    );
  },
);
